import { Stack } from "@mui/material";
import type { JourneyCase } from "../dtos";
import CopyStepsButton from "./copy-steps-button";
import TerminateFlowButton from "./terminate-flow-button";

/**
 * §Terminate + §Clone-steps: case-level actions on the SELECTED application, shown on the right of the
 * board header (deliberately emptied by §HeaderStripped).
 * - "Copy data from another application" — any lead running two or more applications.
 * - Terminate — ACTIVE only (a settled case has nothing to stop); the button itself renders only for
 *   holders of can-terminate-nawy-now-flow.
 */
const CaseHeaderActions = ({
  caseUid,
  cases,
  caseStatus,
}: Readonly<{
  caseUid: string;
  cases: JourneyCase[];
  caseStatus: string | undefined;
}>) => {
  const canCopy = cases.length >= 2;
  const canTerminate = caseStatus === "ACTIVE";
  if (!canCopy && !canTerminate) return null;
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ flexShrink: 0 }}>
      {canCopy && <CopyStepsButton caseUid={caseUid} cases={cases} />}
      {canTerminate && <TerminateFlowButton caseUid={caseUid} />}
    </Stack>
  );
};

export default CaseHeaderActions;
